import { useEffect, useState, memo } from 'react';

import { CloseCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Domains from '@/utils/domains';
import sendAxios from '@/utils/request';
import Utils from '@/utils/Utils';

const RedEnvelopeRainStyle = styled.div`
  position: relative;
  width: 90vw;
  height: 90vh;
  .low-opacity {
    animation: 4s low-opacity 2s forwards;
  }
  .float-ele {
    position: absolute;
    top: -220px;
    animation: run ease-in infinite;
  }
  .star-ele {
    position: absolute;
    top: -120px;
    animation: run ease-in-out infinite;
    z-index: 11;
    background: #fffeff;
    box-shadow: 0px 0px 15px 7px rgba(255, 231, 143, 0.5);
    filter: blur(1px);
  }

  @keyframes run {
    0% {
      transform: translateY(0) translateX(0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    80% {
      opacity: 0.5;
    }
    100% {
      transform: translateY(120vh) translateX(-10vw);
      opacity: 0;
    }
  }
  @keyframes low-opacity {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.8;
    }
  }

  .gift-bag-wrap {
    perspective: 1000px; /* 给容器添加透视效果 */
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 567px;
    height: 345px;
    z-index: 12;
    &.isYX {
      width: 294px;
      height: 411px;
      .gift-bag-ele {
        .gift-bag {
          width: 294px;
          height: 361px;
          .gift-bag-front {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/dl.png') center center
              no-repeat;
            cursor: pointer;
          }
          .gift-bag-back {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/dl3.png') center center
              no-repeat;
            transform: rotateY(180deg);
          }
        }
      }
    }
    &.blue {
      .gift-bag-ele {
        .gift-bag {
          .gift-bag-front {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope2.png')
              center center no-repeat;
            background-size: cover;
          }
          .gift-bag-back {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope-result.png')
              center center no-repeat;
            background-size: cover;
          }
        }
      }
    }
    .gift-bag-ele {
      width: 100%;
      height: 100%;
      animation:
        gift-bag-in-top 1.1s ease-in-out 0s 1 forwards,
        gift-bag-bob-float 0.3s ease-out 1.1s 1 forwards,
        gift-bag-bob 1.5s ease-in-out 1.4s infinite alternate;
      .gift-bag {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        transform-style: preserve-3d; /* 保留3D转换效果 */
        transition: transform 0.6s; /* 添加过渡效果 */
        &.rotate-y {
          transform: rotateY(180deg);
        }
        .gift-bag-face {
          position: absolute;
          backface-visibility: hidden;
        }
        .gift-bag-front {
          width: 245px;
          height: 320px;
          background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/redEnvelope2.svg') center
            center no-repeat;
          cursor: pointer;
        }
        .gift-bag-back {
          width: 100%;
          height: 100%;
          background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/redEnvelope3.svg') center
            center no-repeat;
          transform: rotateY(180deg);
          .gift-coupon-item {
            padding-top: 31px;
            width: 160px;
            height: 105px;
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope-coupon.svg')
              center center no-repeat;
            &.big-bg {
              width: 198px;
              height: 105px;
              background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope-coupon-2.svg')
                center center no-repeat;
            }
          }
        }
      }
    }
  }

  @keyframes gift-bag-in-top {
    0% {
      transform: translateY(-50vh);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    38% {
      transform: translateY(0);
      animation-timing-function: ease-out;
      opacity: 1;
    }
    55% {
      transform: translateY(-65px);
      animation-timing-function: ease-in;
    }
    72% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    81% {
      transform: translateY(-28px);
      animation-timing-function: ease-in;
    }
    90% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    95% {
      transform: translateY(-8px);
      animation-timing-function: ease-in;
    }
    100% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
  }

  @keyframes gift-bag-bob-float {
    100% {
      transform: translateY(0);
    }
  }

  @keyframes gift-bag-bob {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;

let tid;

const AmountDom = ({ giftBagData }) => {
  let content;

  if (giftBagData.isFreeExpress) {
    content = <span className="text-[34px] font-bold">包邮</span>;
  } else if (giftBagData.couponType === 'discount') {
    content = (
      <>
        <span className="text-[34px] inline-block font-bold">{Math.floor(giftBagData.couponDiscount * 10) / 10}</span>
        <span className="text-[20px] inline-block font-normal ml-[3px]">折</span>
      </>
    );
  } else {
    content = (
      <>
        <span className="text-[25px]">￥</span>
        <span className="text-[34px] h-[34px] font-bold">{giftBagData.couponAmount}</span>
      </>
    );
  }
  return <p className="leading-[1] fonts mb-[4px]">{content}</p>;
};

let errMsgId;

const DrawRedEnvelope = ({ closeRain, uuid, theme, isYuanXiao }) => {
  const [giftBagData, setGiftBagData] = useState(false); // 是否打开了券包
  const [errorMsg, setErrorMsg] = useState(null); // 错误提示

  function drawGift() {
    sendAxios({
      method: 'get',
      url: '/async/red/packet/draw',
      params: { uuid },
      baseURL: Domains.lcscActivityUrl,
    }).then(async (res) => {
      if (res.needLogin) {
        Utils.showWindowLogin();
        setErrorMsg('请登陆后操作！');
        return;
      }
      if (res.code === 200 && res.result) {
        setGiftBagData(res.result?.couponItems || []);
      } else {
        setErrorMsg(res.msg || '请重试~');
        errMsgId = setTimeout(() => {
          setErrorMsg(null);
          clearTimeout(errMsgId);
        }, 3000);
      }
    });
  }

  const lenWidth = () => {
    if (giftBagData?.length === 3) {
      return 'w-[496px]';
    } else if (giftBagData?.length === 2) {
      return 'w-[426px]';
    } else {
      return 'w-[198px]';
    }
  };

  return (
    <section className={`gift-bag-wrap relative ${isYuanXiao && 'isYX'} ${theme}`} data-spm="hby">
      <section
        className={`flex shadow-lg bg-white z-[1] text-center rounded-[5px] absolute opacity-0 px-0 py-0 top-[-160px] left-[50%] translate-x-[-50%] text-[14px] ${errorMsg && 'px-[10px] py-[5px] opacity-100 top-[-200px]'} duration-300 transition-all`}
      >
        {errorMsg && <CloseCircleOutlined className="text-[red] mr-[5px]" />}
        {errorMsg && <span className="whitespace-nowrap text-nowrap text-[14px]">{errorMsg}</span>}
      </section>
      <div className="gift-bag-ele">
        <section className={`gift-bag ${giftBagData ? 'rotate-y' : ''}`}>
          <button
            className={`gift-bag-face gift-bag-front w-full h-full ${isYuanXiao && 'text-white relative'}`}
            onClick={drawGift}
          >
            {isYuanXiao && (
              <>
                <p className="absolute top-[90px] left-[50%] w-full translate-x-[-50%] text-[22px] font-[400] ">
                  超级会员日红包雨
                </p>
                <p className="absolute top-[123px] left-[50%] w-full translate-x-[-50%] text-[30px] font-bold">
                  10-1000元满减券
                </p>
              </>
            )}
          </button>
          <section
            className={`gift-bag-face gift-bag-back w-full h-full text-center ${isYuanXiao ? 'pt-[94px]' : 'pt-[100px]'}`}
          >
            {isYuanXiao && <p className="w-full text-[30px] font-bold text-white leading-1">恭喜您抽中</p>}
            <div className={`flex items-center justify-between mx-auto ${lenWidth()}`}>
              {giftBagData &&
                giftBagData.length &&
                giftBagData.map((t, k) => (
                  <div
                    key={k}
                    className={`relative gift-coupon-item ${giftBagData.length < 3 ? 'big-bg' : ''} ${theme === 'blue' ? 'text-[#4587F2]' : 'text-[#FD3F39]'} ${isYuanXiao && 'mt-[35px]'}`}
                  >
                    <p
                      className="absolute text-[#fff] text-[14px] text-center leading-[23px] left-0 top-0 bg-[#4587F2] w-[65px] h-[23px] truncate rounded-tl-[10px] rounded-br-[10px] px-[5px]"
                      title={t.couponTypeName}
                    >
                      {t.couponTypeName}
                    </p>
                    <AmountDom giftBagData={t}></AmountDom>
                    <p className="text-[16px] fonts">
                      {t.isOrderActualMoney ? '实付满' : '满'}
                      {t.minOrderMoney}元可用
                    </p>
                  </div>
                ))}
            </div>
            {giftBagData[0]?.useBeginTime && giftBagData[0]?.useEndTime ? (
              <div className="mt-[14px] text-[14px] text-[#4F5359]">
                有效期{giftBagData[0].useBeginTime}至{giftBagData[0].useEndTime}
              </div>
            ) : (
              <></>
            )}
            {isYuanXiao && (
              <a
                data-spm="ldy"
                href={Domains.lcscActivityUrl + '/super.html'}
                target="_blank"
                title="立创商城-超级会员日-落地页"
                className="w-full text-[18px] block mt-[62px] text-white"
              >
                更多福利
              </a>
            )}
          </section>
        </section>
        {!isYuanXiao && (
          <a
            data-spm="ldy"
            href={Domains.lcscActivityUrl + '/super.html'}
            target="_blank"
            title="立创商城-超级会员日-落地页"
            className="absolute bottom-[30px] left-[50%] translate-x-[-50%] w-[50%] h-[30px]"
          ></a>
        )}
      </div>
      <button
        className="absolute left-[50%] translate-x-[-50%] bottom-[-40px] w-[30px] h-[30px]"
        style={{
          background: `url(https://static.szlcsc.com/ecp/assets/newWeb/modal/close-btn.svg) center center no-repeat`,
          backgroundSize: 'cover',
        }}
        onClick={closeRain}
      ></button>
    </section>
  );
};

const RedEnvelopeRain = memo(({ theme, isYuanXiao }) => {
  const redEnvelopeList = Array.from(new Array(20)); // 红包数量
  const lxList = Array.from(new Array(3)); // 流星数量
  const lx2List = Array.from(new Array(isYuanXiao ? 15 : 3)); // 流星2数量
  const lx3List = Array.from(new Array(9)); // 星星数量
  const [maxLeft, setMaxLeft] = useState(0); // 红包覆盖的最大宽度范围

  useEffect(() => {
    setMaxLeft(1200);
  }, []);

  return (
    <section className={`relative low-opacity w-[1200px] mx-auto h-full`}>
      {redEnvelopeList.map((item, index) => {
        return (
          <img
            className={`float-ele mx-auto z-[13] ${isYuanXiao ? 'w-[61px]' : 'w-[102px]'}`}
            src={
              isYuanXiao
                ? 'https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/dl2.png'
                : theme === 'blue'
                  ? 'https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope.png'
                  : 'https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/redEnvelope.png'
            }
            alt="红包"
            key={index}
            style={{
              left: `${Math.random() * maxLeft}px`,
              animationDuration: `${Math.random() * 2 + 3}s`,
              animationDelay: `${Math.random() * 5}s`,
            }}
            loading="lazy"
            decoding="async"
          />
        );
      })}
      {lxList.map((item, index) => {
        return (
          <img
            className="float-ele z-[12] w-[46px] h-[78px]"
            alt="流星"
            src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/lx.svg"
            style={{
              left: `${Math.random() * maxLeft}px`,
              animationDuration: `${Math.random() * 2 + 2}s`,
            }}
            key={index}
          />
        );
      })}
      {isYuanXiao ? (
        lx2List.map((item, index) => {
          return (
            <img
              className="float-ele z-[13] w-[39px] h-[29px]"
              alt="元宝"
              src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/lx3.png"
              style={{
                left: `${Math.random() * maxLeft}px`,
                animationDuration: `${Math.random() + 2}s`,
              }}
              key={index}
            />
          );
        })
      ) : (
        <>
          {lx2List.map((item, index) => {
            return (
              <img
                className="float-ele z-[11] w-[46px] h-[78px]"
                alt="流星"
                src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/lx2.svg"
                style={{
                  left: `${Math.random() * maxLeft}px`,
                  animationDuration: `${Math.random() + 2}s`,
                }}
                key={index}
              />
            );
          })}
          {lx3List.map((item, index) => {
            return (
              <section
                className="star-ele"
                style={{
                  width: `${Math.round(Math.random() * 8)}px`,
                  height: `${Math.round(Math.random() * 8)}px`,
                  left: `${Math.random() * maxLeft}px`,
                  animationDuration: `${Math.random() * 8 + 2}s`,
                }}
                key={index}
              ></section>
            );
          })}
        </>
      )}
    </section>
  );
});
RedEnvelopeRain.displayName = 'RedEnvelopeRain';

const RedEnvelopeRainPop = ({ onClose, uuid, theme, isYuanXiao }) => {
  const [showRain, setShowRain] = useState(true); // 是否展示红包雨
  const [showGiftBag, setShowGiftBag] = useState(false); // 是否展示券包

  useEffect(() => {
    tid = setTimeout(() => {
      setShowGiftBag(true);
    }, 3000);
    return () => {
      clearTimeout(tid);
    };
  }, []);

  function closeRain() {
    setShowRain(false);
    setShowGiftBag(false);
    onClose();
  }

  return (
    <RedEnvelopeRainStyle>
      {showRain && <RedEnvelopeRain theme={theme} isYuanXiao={isYuanXiao}></RedEnvelopeRain>}
      {showGiftBag && <DrawRedEnvelope theme={theme} isYuanXiao={isYuanXiao} closeRain={closeRain} uuid={uuid} />}
    </RedEnvelopeRainStyle>
  );
};

export default RedEnvelopeRainPop;
